"use client";

import { useClerk, useAuth } from "@clerk/nextjs";
import { useEffect, useRef } from "react";
import { isNativeCapacitorApp } from "@/lib/client/capacitor";
import { NativeClerk } from "@/lib/client/nativeClerk";
import { syncNativeClerkSession } from "@/lib/client/nativeClerkSession";

export default function NativeClerkSessionSync() {
  const clerk = useClerk();
  const { isLoaded, isSignedIn } = useAuth();
  const syncAttempted = useRef(false);
  const hasObservedSignedIn = useRef(false);

  useEffect(() => {
    if (!isNativeCapacitorApp() || !isLoaded || isSignedIn || syncAttempted.current) {
      return;
    }

    syncAttempted.current = true;
    void syncNativeClerkSession(clerk).catch(() => {
      syncAttempted.current = false;
    });
  }, [clerk, isLoaded, isSignedIn]);

  useEffect(() => {
    if (!isNativeCapacitorApp() || !isLoaded) {
      return;
    }

    if (isSignedIn) {
      hasObservedSignedIn.current = true;
      return;
    }

    if (hasObservedSignedIn.current) {
      void NativeClerk.signOut();
      hasObservedSignedIn.current = false;
    }
  }, [isLoaded, isSignedIn]);

  return null;
}
